import { environment } from "src/environments/environment";

const API_BASE_URL = environment.apiBaseURL;

export const API_ENDPOINTS = {
  auth: {
    login: `${API_BASE_URL}/auth/login`,
    me: `${API_BASE_URL}/auth/me`,
    menus: `${API_BASE_URL}/auth/me/menus`,
    changePassword: `${API_BASE_URL}/auth/change-password`
  },
  clientRegistrations: {
    create: `${API_BASE_URL}/client-registrations`,
    list: `${API_BASE_URL}/client-registrations`
  },
  roles: `${API_BASE_URL}/roles`,
  users: `${API_BASE_URL}/users`,
  masterData: `${API_BASE_URL}/master-data`,
  approvalFlows: `${API_BASE_URL}/approval-flows`,
  menus: `${API_BASE_URL}/menus`,
  generators: {
    list: `${API_BASE_URL}/generator-units`
  },
  generatorUnits: `${API_BASE_URL}/generator-units`,
  registrationHierarchy: {
    registrations: `${API_BASE_URL}/registration-hierarchy/registrations`
  }
} as const;
